module.exports = __webpack_public_path__ + "img/user_normal.ecb732d8.svg";